import api from '../technique/api';

export const GeneratePdfBDL = () => ({
  generatePDF: async (policyNumber: string, contratType: string) => {
    if (contratType.toLowerCase() == 'auto') {
      return await api.get(
        `auto/attestation?policyNumber=${policyNumber}&contratType=${contratType}`,
        {
          responseType: 'arraybuffer',
        },
      );
    }
    return await api.patch(
      `common/pdf-generator?policyNumber=${policyNumber}&contratType=${contratType}`,
    );
  },
  getTemporaryLink: async (policyNumber: string, contratType: string) => {
    if (contratType.toLowerCase() == 'auto') {
      return await api.get(
        `auto/attestation/link?policyNumber=${policyNumber}&contratType=${contratType}`,
      );
    }
    return await api.get(
      `common/pdf-generator/link?policyNumber=${policyNumber}&contratType=${contratType}`,
    );
  },
});
